module.exports = __webpack_public_path__ + "components/guide-page/static/icon-wetsuit--spring-b61a605de30adf3b86d77a92cc04d54e.svg";